import React from 'react';
import {get} from 'lodash';

import {
  useModal,
} from '../hooks';

import ImageLoader from './ImageLoader'
import UserWithImage from './UserWithImage'
import Modal from './Modal'

const UserWithImageList = ({
  users = [],
}) => {
  const [
    modal,
    modalSet,
    $submitButton,
  ] = useModal({
    keyboardBindings: true,
  })

  const onToggleModal = () => {
    modalSet(!modal)
  }

  return (
    <React.Fragment>
      <ul className='UserWithImageList'>
        {users.slice(0, 4).map((user) => (
          <li key={user.id}>
            <a
              className='UserWithImageList__a'
              onClick={onToggleModal}
            >
              <div className='ImageBorder'>
                <ImageLoader
                  wrapped={false}
                  url={get(user, 'profileIcon.thumb.url')}
                />
              </div>
            </a>
          </li>
        ))}

        {users.length > 4 &&
          <li>
            <a
              className='UserWithImageList__a UserWithImageList__a--placeholder'
              onClick={onToggleModal}
            >
              +{users.length - 4}
            </a>
          </li>
        }
      </ul>

      <Modal
        isActive={modal}
        onToggleModal={onToggleModal}
      >
        <h3 className='Modal__h3'>Chatroom users</h3>

        <div className='ChatroomUsers'>
          <ul className='ChatroomUsers__ul'>
            {users.map((user) => (
              <li key={user.id}>
                <UserWithImage
                  user={user}
                />
              </li>
            ))}
          </ul>

          <div className='ChatroomUsers__button'>
            <a
              className='Button Button--blue'
              onClick={onToggleModal}
              ref={$submitButton}
            >
              Close
            </a>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
}

export default UserWithImageList;
